//Generated File 
export default class AfterPerformBehavior{
	static readonly Refresh = `Refresh`;
}
